// See webpack.config.js for the list of extensions in the asset/resource rule
const MIME_TYPE_MAPS = {
    png: 'png',
    jpg: 'jpeg',
    gif: 'gif',
};

const webpBackgroundImageMixin = (webp, fallback) => {
    const [, ext] = fallback.match(/.*\.(\w+)$/);
    // background-image: url(webp) is for browsers that support webp, but not the image set with type (Chromium)
    // background-image: image-set() is for browsers that may not support webp
    return `
    background-image: url("${webp}");
    background-image: image-set(
        url("${webp}") type("image/webp"), url("${fallback}") type("image/${MIME_TYPE_MAPS[ext]}")
    );`;
};
export default webpBackgroundImageMixin;
